export const lookerParams = {
  lookerPath: {
    models: process.env.REACT_APP_LOOKER_PROJECT,
    addressableTab: {
      table: process.env.REACT_APP_ADDRESSABLE_TAB_TABLE_EMBED_PATH,
      chart: process.env.REACT_APP_ADDRESSABLE_TAB_CHART_EMBED_PATH,
    },
    inputvariablesTab: {
      table: process.env.REACT_APP_INPUTVARIABLES_TAB_TABLE_EMBED_PATH,
      chart: process.env.REACT_APP_INPUTVARIABLES_TAB_CHART_EMBED_PATH,
    },
    revenueOpportunityTab: {
      table: process.env.REACT_APP_REVENUEOPPORTUNITY_TAB_TABLE_EMBED_PATH,
      chart: process.env.REACT_APP_REVENUEOPPORTUNITY_TAB_CHART_EMBED_PATH,
    },
    revenueByPayorMixTab: {
      table: process.env.REACT_APP_REVENUEBYPAYORMIX_TAB_TABLE_EMBED_PATH,
      chart: process.env.REACT_APP_REVENUEBYPAYORMIX_TAB_CHART_EMBED_PATH,
    },
    addrRevByPayorMixTab: {
      table: process.env.REACT_APP_ADDRREVBYPAYORMIX_TAB_TABLE_EMBED_PATH,
      chart: process.env.REACT_APP_ADDRREVBYPAYORMIX_TAB_CHART_EMBED_PATH,
    },
    marginByPayorMixTab: {
      table: process.env.REACT_APP_MARGINBYPAYORMIX_TAB_TABLE_EMBED_PATH,
      chart: process.env.REACT_APP_MARGINBYPAYORMIX_TAB_CHART_EMBED_PATH,
    },
    addrMarginByPayorMixTab: {
      table: process.env.REACT_APP_ADDRMARGINBYPAYORMIX_TAB_TABLE_EMBED_PATH,
      chart: process.env.REACT_APP_ADDRMARGINBYPAYORMIX_TAB_CHART_EMBED_PATH,
    },
    fiveYearProjectionsTab: {
      table: process.env.REACT_APP_5YRPROJECTIONS_TAB_TABLE_EMBED_PATH,
      chart: process.env.REACT_APP_5YRPROJECTIONS_TAB_CHART_EMBED_PATH,
    },
    readmittanceTable: process.env.REACT_APP_PATIENT_RISK_EMBED_PATH,
    adherenceTable: process.env.REACT_APP_PATIENT_RISK_ADHERENCE_EMBED_PATH,
    etlErrorsTable: process.env.REACT_APP_ETL_ERRORS_EMBED_PATH,
    lookerDashboard: process.env.REACT_APP_DASHBOARD_EMBED_PATH,
  },
  actualsLookerPath: {
    models: [
      process.env.REACT_APP_LOOKER_PROJECT,
      process.env.REACT_APP_LOOKER_PROJECT_EXPLORES,
    ].join(","),
    rxPerPrescriber: {
      look: process.env.REACT_APP_ACTUALS_RX_PER_PRESCRIBER,
    },
    fillPerPrescriber: {
      look: process.env.REACT_APP_ACTUALS_FILL_PER_PRESCRIBER,
    },
    rxCapture: {
      look: process.env.REACT_APP_ACTUALS_RX_CAPTURE,
    },
    transmitReport: {
      look: process.env.REACT_APP_TRANSMIT_SUMMARY_EMBED_PATH,
    },
    dispenseFinancial: {
      dashboard: process.env.REACT_APP_ACTUALS_DISPENSE_FINANCIAL,
    },
    dispensePrescriber: {
      dashboard: process.env.REACT_APP_ACTUALS_DISPENSE_PRESCRIBER,
    },
    emrCapture: {
      dashboard: process.env.REACT_APP_ACTUALS_EMR_CAPTURE,
    },
    emrPrescriptions: {
      dashboard: process.env.REACT_APP_ACTUALS_EMR_PRESCRIPTIONS,
    },
  },
  exploresLookerPath: {
    models: process.env.REACT_APP_LOOKER_PROJECT_EXPLORES,
    explores: process.env.REACT_APP_LOOKER_EXPLORES || "",
  },
};
